import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import * as graphql from 'generated/graphql';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';
import { CompetencyLevelsInput } from 'packages/kakapo-ui-application/pages/evaluation-submissions/input/CompetencyInput';
import { ButtonSize } from 'packages/kakapo-ui-kit/types/Button';

import Paragraph from '../../common/Paragraph';
import Modal, { ModalBackground, ModalContent } from '../../modals/Modal';
import ModalHeader, { ModalHeaderTitle } from '../../modals/ModalHeader';
import PlainButton from '../../buttons/PlainButton';
import PrimaryButton from '../../buttons/PrimaryButton';
import QuillText from '../../editors/QuillText';

export default function GoalCreateCompetencyModal(props: {
	competency: graphql.Competency;
	onCancel: () => void;
	onSave: () => void;
}) {
	const { t } = useTranslation();
	const { localize } = useLocalize();

	const description = localize(props.competency.description ?? [])?.text;

	return (
		<ModalBackground>
			<Modal>
				<ModalHeader onCancel={() => props.onCancel()}>
					<ModalHeaderTitle>
						{t('goals.create.form.competency.modal.title')}: {localize(props.competency.title).text}
					</ModalHeaderTitle>
				</ModalHeader>
				<ModalContent>
					<Paragraph color="lightBlueDark">
						{t('goals.create.form.competency.modal.instruction')}
					</Paragraph>
					<Box mt={2}>
						<QuillText quill={description} />
					</Box>
					<Box mt={4}>
						<CompetencyLevelsInput
							competency={props.competency}
							name="competencyLevelInput"
							party={graphql.EvaluationSubmissionParty.Manager}
						/>
					</Box>
					<Flex mt={4} justifyContent="space-between">
						<PlainButton size={ButtonSize.Medium} onClick={props.onCancel}>
							{t('goals.create.form.competency.modal.cancelButton.title')}
						</PlainButton>
						<PrimaryButton size={ButtonSize.Medium} onClick={props.onSave}>
							{t('goals.create.form.competency.modal.addButton.title')}
						</PrimaryButton>
					</Flex>
				</ModalContent>
			</Modal>
		</ModalBackground>
	);
}
